<nav
    aria-label="breadcrumb"
    class="d-none d-md-inline-block wrapper_breadcrumb"
>
    <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
        <li class="breadcrumb-item">
            <a href="dashboard">
                <i class="fa fa-home"></i>
            </a>
        </li>
        <li class="breadcrumb-item">{{ title }}</li>
        <li class="breadcrumb-item" aria-current="page">
            <a>{{ active_item }}</a>
        </li>
    </ol>
</nav>
